import React from 'react';
import Panel from './Panel';
import DashboardAdmin from '../../components/Panel/Dashboard/DashboardAdministrador';



const DashboardAdminPage = () => {

  return (
    <Panel>
      <div>
        <DashboardAdmin />
      </div>
    </Panel>

  );
};

export default DashboardAdminPage;



/** WEBPACK FOOTER **
 ** ./src/containers/Panel/DashboardAdminPage.js
 **/